import { Link, useLocation, useNavigate } from "react-router-dom";
import mainIcon from "../../../assets/mainIcon.png";
import routes from "../../../routes/routes";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../features/auth/auth.slice";

const Sidebar = () => {
  const location = useLocation();
  const sidebarRoutes = routes.filter(
    (route) => route.layout === "app" && route.icon
  );
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <aside className="w-28 bg-primary shadow-md flex-shrink-0 hidden md:flex md:flex-col h-screen">
      {/* Header */}
      <div className="h-[57px] flex items-center justify-center flex-shrink-0">
        <img className="w-12" src={mainIcon} alt="logo" />
      </div>
      <hr className="border-white/20" />

      {/* Navigation - takes up remaining space and scrolls if needed */}
      <nav className="mt-6 flex-1 overflow-y-auto">
        {sidebarRoutes.map((route) => {
          const Icon = route.icon;
          const isActive = location.pathname === route.path;
          return (
            <div key={route.path}>
              <Link
                to={route.path}
                className={`flex flex-col items-center justify-center py-2 text-xs font-semibold text-white gap-2 transition-colors mx-2 rounded-md ${
                  isActive ? "bg-white/20" : "hover:bg-white/10"
                }`}
              >
                {Icon && <Icon className="text-lg" />}
                <span>{route.name}</span>
              </Link>
              <hr className="border-white/20 my-4" />
            </div>
          );
        })}
      </nav>

      {/* Footer - stays at bottom */}
      <footer className="px-6 py-4  shadow-sm flex-shrink-0">
        <div className="flex flex-col items-center justify-between w-full space-y-2">
          {/* <p className="text-sm font-bold text-white truncate w-full text-center">
            {user?.username}
          </p> */}
          <button
            onClick={handleLogout}
            type="button"
            className="flex items-center text-sm font-semibold p-2 rounded-md bg-primary border-white text-white  hover:bg-primary/80 transition-colors w-full justify-center"
          >
            Logout
          </button>
        </div>
      </footer>
    </aside>
  );
};

export default Sidebar;